module.exports = MaterialUI.Tab;